<template>
  <div
    style="background-image: url(&quot;/images/background.png&quot;)"
    class="bg-no-repeat bg-cover md:bg-contain bg-center"
  >
    <div class="container pt-16 md:py-20">
      <h3
        class="font-display text-primary text-2xl md:text-3xl lg:text-[40px] font-semibold mb-8 md:mb-12"
      >
        {{ $t("home.reviews.title") }}
      </h3>
      <div class="-mx-2">
        <ClientOnly>
          <swiper-container
            slides-per-view="1"
            :space-between="25"
            :breakpoints="{
              768: {
                slidesPerView: 3,
              },
            }"
            :pagination="{
              clickable: true,
            }"
          >
            <swiper-slide v-for="(review, idx) in reviews" :key="idx">
              <div class="p-2 mb-8">
                <div class="bg-white rounded-2xl px-10 py-7 shadow-md">
                  <p class="text-primary text-lg font-semibold">
                    {{ review.author }}
                  </p>
                  <div
                    class="whitespace-nowrap flex mb-3 md:my-3"
                    v-if="reviews.stars"
                  >
                    <img
                      v-for="i in review.stars"
                      src="/icons/star.svg"
                      class="w-4 h-4"
                    />
                  </div>
                  <p class="text-brand-gray font-light">
                    {{ review.description }}
                  </p>
                </div>
              </div>
            </swiper-slide>
          </swiper-container>
        </ClientOnly>
      </div>
    </div>
  </div>
</template>

<script setup type="ts">

const { locale } = useI18n();
const reviews = ref([])
if (locale.value === "pt") {
  reviews.value = [
    {
      author: "Beatriz, Lisboa",
      stars: 0,
      description:
        "Uma caixa completíssima, cheia de cupões úteis para toda a família e também para quem está prestes a chegar. Achei super prática e interessante. Obrigada por criarem algo assim e pensarem em nós num momento tão especial da vida.",
    },
    {
      author: "Carmo, Porto",
      stars: 0,
      description:
        "Adoro! É uma “happy box” realmente útil e muito bem pensada. Perfeita para descobrir produtos para recém-nascidos. Nota-se o carinho com que foi preparada ❤️🥰",
    },
    {
      author: "Maria do Mar, Faro",
      stars: 0,
      description:
        "A Happy Box é linda e muito funcional. Inclui bons descontos e amostras que poderei experimentar quando a minha menina nascer. O meu item favorito são as meias, são adoráveis! Gostei imenso de tudo.",
    },
    {
      author: "Helena, Coimbra",
      stars: 0,
      description:
        "Faz honra ao nome: uma autêntica “happy box”. Fiquei muito satisfeita. Estou ansiosa por experimentar todos os produtos com o meu bebé.",
    },
    {
      author: "Ana, Braga",
      stars: 0,
      description:
        "O conteúdo surpreendeu-me muito pela positiva. Inclui produtos essenciais e de muito boa qualidade. Parece-me uma iniciativa fantástica.",
    },
    {
      author: "Rita, Évora",
      stars: 0,
      description:
        "Uma caixa preciosa, cheia de produtos realmente úteis que sei que vou aproveitar assim que o meu pequeno nascer. Muito recomendável!",
    },
  ];
}
if (locale.value === "es") {
  reviews.value = [
    {
      author: "Lucía, Madrid",
      stars: 0,
      description:
        "Una caja completísima, llena de cupones útiles para toda la familia y también para lo que está por llegar. Me ha parecido súper práctica e interesante. Gracias por crear algo así y pensar en nosotras en un momento tan especial de la vida.",
    },
    {
      author: "Carmen, Sevilla",
      stars: 0,
      description:
        "¡Me encanta! Es una “happy box” realmente útil y muy bien pensada. Perfecta para descubrir productos para recién nacidos. Se nota el cariño con el que está hecha ❤️🥰",
    },
    {
      author: "Mari Cruz, Málaga",
      stars: 0,
      description:
        "La Happy Box es preciosa y muy funcional. Incluye buenos descuentos y muestras que podré probar cuando nazca mi niña. Mi favorito son los calcetines, ¡son adorables! Todo me ha encantado.",
    },
    {
      author: "Elena, Bilbao",
      stars: 0,
      description:
        "Hace honor a su nombre: una auténtica “happy box”. He quedado muy satisfecha. Estoy deseando probar todos los productos con mi bebé.",
    },
    {
      author: "Alba, Valencia",
      stars: 0,
      description:
        "El contenido me sorprendió muchísimo para bien. Incluye productos esenciales y de muy buena calidad. Me parece una iniciativa fantástica.",
    },
    {
      author: "Rocío, Zaragoza",
      stars: 0,
      description:
        "Una caja preciosa, llena de productos realmente útiles que sé que voy a aprovechar en cuanto nazca mi pequeño. ¡Muy recomendable!",
    },
  ];
}
</script>
